import $ from 'jquery/dist/jquery.min'

$('.js-smooth-scroll').click(function(e) {
  e.preventDefault();
  const target = this.hash
  const $target = $(target);
  $('html, body').animate({
    scrollTop: $target.offset().top
  }, 800);
});



// WEBPACK FOOTER //
// ./web/src/app/javascripts/components/SmoothScroll.jsx